var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompanyIcon = function SvgCompanyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#495057",
    d: "M17 13.833h1.667V15.5H.334v-1.667h1.667v-12.5A.833.833 0 0 1 2.834.5h8.333a.833.833 0 0 1 .834.833v12.5h1.666V5.5h2.5a.833.833 0 0 1 .834.833zM5.335 7.167v1.666h3.333V7.167zm0-3.334V5.5h3.333V3.833z"
  })));
};
export default SvgCompanyIcon;